import { Group } from '@visx/group'
import { Circle } from '@visx/shape'
import cx from 'classnames'

import {
  ACTIVE_DOT_STROKE,
  ARROW_LINE_WIDTH,
  DOT_RADIUS,
  INACTIVE_DOT_STROKE,
} from './constants'

type Props = {
  left: number
  count: number
  isAnyVersionLockedToChangeset?: boolean
  isAnyVersionActive?: boolean
}

export const MutipleVersionCircles = ({
  left,
  count,
  isAnyVersionLockedToChangeset,
  isAnyVersionActive,
}: Props) => (
  <Group
    top={ARROW_LINE_WIDTH / 2}
    left={left}
    className="z-1 cursor-pointer hover:opacity-80 stroke-amaze-ink dark:stroke-amaze-inkBright"
  >
    <Circle
      cy={-DOT_RADIUS / 2}
      cx={0}
      r={DOT_RADIUS - ACTIVE_DOT_STROKE}
      strokeWidth={INACTIVE_DOT_STROKE}
      className={
        isAnyVersionLockedToChangeset
          ? 'fill-error-500'
          : 'fill-warning-500 dark:fill-warning-300'
      }
    />
    {count > 2 && (
      <Circle
        cy={0}
        cx={0}
        r={DOT_RADIUS - ACTIVE_DOT_STROKE}
        strokeWidth={INACTIVE_DOT_STROKE}
        className={
          isAnyVersionLockedToChangeset
            ? 'fill-error-500'
            : 'fill-warning-500 dark:fill-warning-300'
        }
      />
    )}
    <Circle
      cy={DOT_RADIUS / 2}
      cx={0}
      r={isAnyVersionActive ? DOT_RADIUS : DOT_RADIUS - ACTIVE_DOT_STROKE}
      strokeWidth={isAnyVersionActive ? ACTIVE_DOT_STROKE : INACTIVE_DOT_STROKE}
      className={cx(
        'z-1 cursor-pointer',
        {
          'stroke-timeline-dotActive': isAnyVersionActive,
        },
        isAnyVersionLockedToChangeset
          ? 'fill-error-500'
          : 'fill-warning-500 dark:fill-warning-300',
      )}
    />
  </Group>
)
